export const THEME_MODES = ['light', 'dark'];

export const ACCENT_FAMILIES = {
  standard: {
    name: 'Standard',
    icon: 'mdi-compass-outline',
    primary: '#5F8FB2',
    primaryDark: '#446B86',
    secondary: '#8DAE83',
    secondaryDark: '#6E8E67',
    accent: '#C99A48',
    accentRgb: '95, 143, 178',
  },
  green: {
    name: 'Green',
    icon: 'mdi-leaf',
    primary: '#5D966F',
    primaryDark: '#3F7052',
    secondary: '#97B879',
    secondaryDark: '#708D59',
    accent: '#C0A15A',
    accentRgb: '93, 150, 111',
  },
  blue: {
    name: 'Blue',
    icon: 'mdi-water-outline',
    primary: '#5F8FCB',
    primaryDark: '#426A9D',
    secondary: '#79B7C8',
    secondaryDark: '#5A8D9D',
    accent: '#C7A45A',
    accentRgb: '95, 143, 203',
  },
  red: {
    name: 'Red',
    icon: 'mdi-maple-leaf',
    primary: '#B86B61',
    primaryDark: '#8B4E47',
    secondary: '#A8896F',
    secondaryDark: '#7D6755',
    accent: '#D2A05D',
    accentRgb: '184, 107, 97',
  },
  purple: {
    name: 'Purple',
    icon: 'mdi-lavender',
    primary: '#8B78B8',
    primaryDark: '#66528F',
    secondary: '#79A2B5',
    secondaryDark: '#597E8E',
    accent: '#C9A25D',
    accentRgb: '139, 120, 184',
  },
};

export const ACCENT_KEYS = Object.keys(ACCENT_FAMILIES);

const lightBase = {
  dark: false,
  background: '#F3EFE4',
  surface: '#FFFDF6',
  error: '#C96D64',
  info: '#86BFE0',
  success: '#7FAE82',
  warning: '#D8A95B',
};

const darkBase = {
  dark: true,
  background: '#101B17',
  surface: '#1E3129',
  error: '#E07A70',
  info: '#8DC8E8',
  success: '#91C991',
  warning: '#D8A95B',
};

export function isThemeMode(value) {
  return THEME_MODES.includes(value);
}

export function isAccentFamily(value) {
  return ACCENT_KEYS.includes(value);
}

export function normalizeThemeMode(value) {
  return isThemeMode(value) ? value : 'dark';
}

export function normalizeAccentFamily(value) {
  return isAccentFamily(value) ? value : 'standard';
}

export function getAccentDefinition(value) {
  return ACCENT_FAMILIES[normalizeAccentFamily(value)];
}

export function getVuetifyThemeName(mode = 'dark', accent = 'standard') {
  const normalizedMode = normalizeThemeMode(mode);
  const normalizedAccent = normalizeAccentFamily(accent);
  return `bm${normalizedMode === 'dark' ? 'Dark' : 'Light'}${normalizedAccent[0].toUpperCase()}${normalizedAccent.slice(1)}`;
}

export function buildVuetifyThemes() {
  return ACCENT_KEYS.reduce((themes, key) => {
    const family = ACCENT_FAMILIES[key];
    themes[getVuetifyThemeName('light', key)] = {
      dark: false,
      colors: {
        background: lightBase.background,
        surface: lightBase.surface,
        primary: family.primary,
        'primary-darken-1': family.primaryDark,
        secondary: family.secondary,
        'secondary-darken-1': family.secondaryDark,
        accent: family.accent,
        error: lightBase.error,
        info: key === 'blue' ? family.secondary : lightBase.info,
        success: lightBase.success,
        warning: lightBase.warning,
      },
    };
    themes[getVuetifyThemeName('dark', key)] = {
      dark: true,
      colors: {
        background: darkBase.background,
        surface: darkBase.surface,
        primary: family.primary,
        'primary-darken-1': family.primaryDark,
        secondary: family.secondary,
        'secondary-darken-1': family.secondaryDark,
        accent: family.accent,
        error: darkBase.error,
        info: key === 'blue' ? family.secondary : darkBase.info,
        success: darkBase.success,
        warning: darkBase.warning,
      },
    };
    return themes;
  }, {});
}
